import React from "react";

function RequestAdditionalDocumentsIcon() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="45" cy="45" r="45" fill="#FF7A18" fill-opacity="0.52" />
      <circle cx="45.0006" cy="45.0006" r="32.1429" fill="#FFD694" />
      <path
        d="M45 36.75C44.5941 36.75 44.2228 37.095 44.25 37.5L44.625 47.625C44.625 47.7245 44.6645 47.8198 44.7348 47.8902C44.8052 47.9605 44.9005 48 45 48C45.0995 48 45.1948 47.9605 45.2652 47.8902C45.3355 47.8198 45.375 47.7245 45.375 47.625L45.75 37.5C45.7772 37.095 45.4059 36.75 45 36.75Z"
        stroke="#F44336"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45 53.25C45.4142 53.25 45.75 52.9142 45.75 52.5C45.75 52.0858 45.4142 51.75 45 51.75C44.5858 51.75 44.25 52.0858 44.25 52.5C44.25 52.9142 44.5858 53.25 45 53.25Z"
        stroke="#FF3C3C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default RequestAdditionalDocumentsIcon;
